import { LitElement } from "lit";
export class USBrandCampaign extends LitElement {
    constructor() {
        super();
        this.oneMinuteEngagement = false;
        //window.dataLayer = window.dataLayer || [];
    }
    track(data) {
        window.dataLayer.push(data);
    }
    trackDownload(event) {
        const target = this._getAnchor(event);
        const url = target.getAttribute('href');
        let urlBits = url.split('/');
        const fileName = urlBits[urlBits.length - 1];
        let componentLocation = target.getAttribute('data-tracking-location');
        if (!componentLocation) {
            componentLocation = this.tagName;
        }
        this.track({
            "event": "file_download",
            "detailed_event": "Download Link Clicked",
            "event_data": {
                "file_extension": "pdf",
                "file_name": fileName,
                "link_url": url,
                "location": componentLocation
            },
            "file_extension": "pdf",
            "file_name": fileName,
            "link_url": url,
            "location": componentLocation
        });
    }
    trackCallout(event) {
        const target = this._getAnchor(event);
        let link_text = target.innerText;
        if (target.getAttribute('data-card-title')) {
            link_text = target.getAttribute('data-card-title');
        }
        this.track({ event_data: null }); // Clear the previous event_data object.
        this.track({
            "event": "callout_click",
            "detailed_event": "Callout Clicks",
            "event_data": {
                "category": this.tagName,
                "link_text": link_text,
                "link_type": "External Link",
                "link_url": target.getAttribute('href'),
                "type": "card"
            },
            "link_text": link_text,
            "link_url": target.getAttribute('href'),
            "name": "<name>",
            "type": "card"
        });
    }
    trackCarouselClick(event) {
        const target = this._getAnchor(event);
        let linkText = target.getAttribute('data-carousel-title');
        this.track({ event_data: null }); // Clear the previous event_data object.
        this.track({
            "event": "specific_carousel_slide",
            "detailed_event": "Carousel Click",
            "action": target.getAttribute('href'),
            "event_data": {
                "category": "",
                "heading": "SIM Logo Carousel",
                "index": "",
                "link_id": "",
                "link_text": linkText,
                "link_type": "External",
                "link_url": target.getAttribute('href')
            },
            "name": "<name>"
        });
    }
    _getAnchor(event) {
        let target = event.target;
        while (!target.hasAttribute('href')) {
            target = target.parentNode;
        }
        return target;
    }
    trackLink(event) {
        const target = this._getAnchor(event);
        let link_text = target.innerText;
        if (target.getAttribute('data-link-title')) {
            link_text = target.getAttribute('data-link-title');
        }
        this.track({ event_data: null });
        this.track({
            "event": "linkOrButtonClick",
            "detailed_event": "Link or Button Click",
            "event_data": {
                "category": this.tagName,
                "link_text": link_text,
                "link_type": "External Link",
                "link_url": target.getAttribute('href')
            },
            "link_text": link_text,
            "link_type": "External Link",
            "link_url": target.getAttribute('href')
        });
    }
    trackFooterLink(event) {
        const target = this._getAnchor(event);
        let link_text = target.innerText;
        if (target.getAttribute('data-link-title')) {
            link_text = target.getAttribute('data-link-title');
        }
        this.track({ event_data: null });
        this.track({
            "event": "footer_navigation",
            "detailed_event": "Footer Navigation",
            "event_data": {
                "category": "",
                "link_text": link_text,
                "link_type": "External Link",
                "link_url": target.getAttribute('href')
            },
            "link_text": link_text,
            "link_type": "External Link",
            "link_url": target.getAttribute('href')
        });
    }
}
//# sourceMappingURL=us-branding.js.map